import { getGraphql } from '../static/graphql/getGraphql.js'
import { FeatureFlags } from '~/utils/feature-flags.enum.js'

/* eslint-disable */

export const state = () => ({
  entityLoading: [],
  contractsCount: null,
  paymentsCount: null,
  offersCount: null,
  sameAsEntities: null,
  featureFlag: {},
})

export const mutations = {
  setEntityLoading(state, payload) {
    state.entityLoading.push(payload.key)

    // unique the array
    state.entityLoading = [...new Set(state.entityLoading)]

    // remove
    if (!payload.value) {
      state.entityLoading = state.entityLoading.filter((e) => e !== payload.key)
    }
  },
  clearData(state, payload) {
    state.entityLoading = []
    state.contractsCount = null
    state.paymentsCount = null
    state.offersCount = null
    state.sameAsEntities = null
  },
  setContractsCount(state, payload) {
    state.contractsCount = payload
  },
  setPaymentsCount(state, payload) {
    state.paymentsCount = payload
  },
  setOffersCount(state, payload) {
    state.offersCount = payload
  },
  setSameAsEntities(state, payload) {
    state.sameAsEntities = payload
  },
  setFeatureFlags(state, payload) {
    state.featureFlag = { ...state.featureFlag, ...payload }
  },
}

export const actions = {
  getContactPageFlag(context) {
    context.commit('setEntityLoading', {
      key: 'getContactPageFlag',
      value: true,
    })
    this.$featureFlag
      .isEnabled([
        {
          name: 'ff_new_profile_settings',
        },
      ])
      .then((result) => {
        context.commit('setFeatureFlags', { ...result })
        context.commit('setEntityLoading', {
          key: 'getContactPageFlag',
          value: false,
        })
      })
      .catch((error) => {
        console.log(error)
        context.commit('setEntityLoading', {
          key: 'getContactPageFlag',
          value: false,
        })
      })
  },
  getUsioFlag(context) {
    context.commit('setEntityLoading', {
      key: 'getUsioFlag',
      value: true,
    })
    return this.$featureFlag
      .isEnabled([{ name: FeatureFlags.UsioPaymentEnabled }], true)
      .then((result) => {
        context.commit('setFeatureFlags', { ...result })
        context.commit('setEntityLoading', {
          key: 'getUsioFlag',
          value: false,
        })
      })
      .catch((error) => {
        console.log(error)
        context.commit('setEntityLoading', {
          key: 'getUsioFlag',
          value: false,
        })
      })
  },
  getSocialMaintenanceMode(context) {
    context.commit('setEntityLoading', {
      key: 'getSocialMaintenanceMode',
      value: true,
    })
    return this.$featureFlag
      .isEnabled([{ name: FeatureFlags.SocialMaintenanceMode }], true)
      .then((result) => {
        context.commit('setFeatureFlags', { ...result })
        context.commit('setEntityLoading', {
          key: 'getSocialMaintenanceMode',
          value: false,
        })
      })
      .catch((error) => {
        console.log(error)
        context.commit('setEntityLoading', {
          key: 'getSocialMaintenanceMode',
          value: false,
        })
      })
  },
  async switchEntity(context, targetEntityUuid) {
    try {
      context.commit('setEntityLoading', {
        key: 'switchAccounts',
        value: true,
      })
      const response = await this.$axios.$post('/AUTH_URL/generate-token', {
        targetEntityUuid,
      })
      this.$cookies.set('auth._token.uptogether', response.access_token, {
        path: '/',
        domain: process.env.COOKIE_DOMAIN,
        maxAge: 60 * 60 * 24 * 7,
      })
      this.$cookies.set('refresh._token.uptogether', response.refresh_token, {
        path: '/',
        domain: process.env.COOKIE_DOMAIN,
        maxAge: 60 * 60 * 24 * 7,
      })
      window.location.reload()
      return true
    } catch (e) {
      console.log(e)
      context.commit('setEntityLoading', {
        key: 'switchAccounts',
        value: false,
      })
      return false
    }
  },
  async getSameAsEntities(context) {
    try {
      context.commit('clearData')
      const query = await getGraphql('query-me-same-as-entities.graphql')
      context.commit('setEntityLoading', {
        key: 'getSameAsEntities',
        value: true,
      })
      const response = await this.$axios.$post('/GRAPHQL_URL/', { query })
      context.commit(
        'setContractsCount',
        response.data.me.sameAsEntitiesStatistics.contractsCount
      )
      context.commit(
        'setPaymentsCount',
        response.data.me.sameAsEntitiesStatistics.paymentsCount
      )
      context.commit(
        'setOffersCount',
        response.data.me.sameAsEntitiesStatistics.offersCount
      )
      const sameAsEntities = (
        response.data.me.sameAsEntitiesStatistics.results || []
      ).map(JSON.parse)

      context.commit(
        'setSameAsEntities',
        sameAsEntities.filter((item) =>
          item.meta.email.includes('@uptogether.org')
        )
      )
      context.commit('setEntityLoading', {
        key: 'getSameAsEntities',
        value: false,
      })
    } catch (e) {
      console.log(e)
      context.commit('setEntityLoading', {
        key: 'getSameAsEntities',
        value: false,
      })
    } finally {
      context.commit('setEntityLoading', {
        key: 'getSameAsEntities',
        value: false,
      })
    }
  },
}
